import { render, staticRenderFns } from "./BeeswarmLoader.vue?vue&type=template&id=fd5ae3da&"
import script from "./BeeswarmLoader.vue?vue&type=script&lang=js&"
export * from "./BeeswarmLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports